/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useMemo } from 'react';
import { Chip, styled, Theme } from '@mui/material';
import { TSocialMedia, TStreamType } from 'src/models/general';
import ClearIcon from '@mui/icons-material/Clear';
import { SxProps } from '@mui/system';
import { getSymbolByStreamType } from 'src/utils/getSymbolByStreamType';
import GetSocialMediaIcon from '../GetSocialMediaIcon';

export interface Props {
  id: string;
  socialMedia: TSocialMedia;
  name: string;
  streamType?: TStreamType;
  onRemove?: (id: string) => void;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  labelColor?: string;
}

const ChipCustom = styled(Chip)<{ labelColor?: string }>(
  ({ theme, labelColor }) => `
    background-color: ${theme.palette.primary.light};
    border-radius: ${theme.spacing(1)};
    padding: 10px ${theme.spacing(2)};
    margin: 0 0 8px 12px;
    height: 29px;
    .MuiChip-label {
        color: ${labelColor ? labelColor : '#0A789D'};
        font-size: 14px;
        line-height: 130%;
        margin: 0 4px;
    }
    .MuiChip-avatarSmall {
        width: 14px;
        color: #0A789D;
    }
    .MuiChip-deleteIcon {
        font-size: 14px;
        color: ${labelColor ? labelColor : '#0A789D'};
    }
  `
);

const ChipSocialMediaObject: FC<Props> = ({
  id,
  socialMedia,
  name,
  streamType,
  onClick,
  onRemove,
  sx,
  labelColor
}) => {
  const symbol = useMemo(
    () => (streamType === 'hashtag' ? '#' : getSymbolByStreamType(streamType)),
    [streamType]
  );

  return (
    <ChipCustom
      variant="filled"
      deleteIcon={<ClearIcon />}
      onDelete={onRemove ? () => onRemove(id) : undefined}
      avatar={<GetSocialMediaIcon socialMedia={socialMedia} />}
      label={`${streamType !== 'account' ? symbol : ''}${name}`}
      size="small"
      sx={sx}
      onClick={onClick}
      labelColor={labelColor}
    />
  );
};

export default ChipSocialMediaObject;
